'use client'

import dynamic from 'next/dynamic'
import { FC } from 'react'

const MarkdownView = dynamic(() => import('@/components/ui/markdown-view/markdown-view').then((mod) => mod.MarkdownView), { ssr: false })

export interface SPPerformerSectionProps {
  name: string
  profile?: string | null
}

const SPPerformerSection: FC<SPPerformerSectionProps> = ({ name, profile }) => {
  return (
    <div className="sp-detail-section">
      <div className="sp-detail-section-label">動画の出演者</div>
      <div className="sp-detail-section-value">{name}</div>
      {profile && (
        <div style={{ marginTop: '8px' }}>
          <MarkdownView content={profile} />
        </div>
      )}
    </div>
  )
}

export default SPPerformerSection
